import { useEffect } from 'react';

/**
 * スクロールロックの参照カウンター
 * 複数のコンポーネントが同時にスクロールをロックする場合に、
 * すべてのロックが解除されるまでスクロールを無効に保つ
 */
let lockCount = 0;
let scrollY = 0;

/**
 * スクロールをロックする内部関数
 */
const lockScroll = () => {
  if (lockCount === 0) {
    // 初回のロック時のみスクロール位置を保存してスタイルを適用
    scrollY = window.scrollY;

    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.width = '100%';
    document.body.style.top = `-${scrollY}px`;
    document.body.style.left = '0';
    document.body.style.right = '0';
  }
  lockCount++;
};

/**
 * スクロールのロックを解除する内部関数
 */
const unlockScroll = () => {
  lockCount = Math.max(0, lockCount - 1);

  if (lockCount === 0) {
    // すべてのロックが解除された時のみスクロールを復元
    document.body.style.overflow = '';
    document.body.style.position = '';
    document.body.style.width = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';

    window.scrollTo(0, scrollY);
  }
};

/**
 * スクロール制御用のカスタムフック
 * モーダルやダイアログが開いている時に背景のスクロールを無効にする
 *
 * 複数のコンポーネントが同時にこのフックを使用しても、
 * 参照カウント方式により正しく動作します。
 *
 * @param isLocked - trueの場合はスクロールをロック、falseの場合はロックを解除
 *
 * @example
 * ```tsx
 * const [isOpen, setIsOpen] = useState(false);
 * useScrollLock(isOpen);
 * ```
 */
export const useScrollLock = (isLocked: boolean) => {
  useEffect(() => {
    if (isLocked) {
      lockScroll();
    }

    // クリーンアップ関数: isLockedの値に関わらず、マウント時にロックしていたら必ず解除
    return () => {
      if (isLocked) {
        unlockScroll();
      }
    };
  }, [isLocked]);
};
